var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 23,
    viewBox: "0 0 30 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.8556 7.42696C7.15404 7.13001 7.15524 6.64736 6.85829 6.34892C6.56134 6.05048 6.07868 6.04928 5.78025 6.34623L6.8556 7.42696ZM1.18361 10.92C0.88517 11.217 0.883966 11.6996 1.18092 11.998C1.47787 12.2965 1.96053 12.2977 2.25896 12.0007L1.18361 10.92ZM2.25896 10.92C1.96053 10.6231 1.47787 10.6243 1.18092 10.9227C0.883966 11.2212 0.88517 11.7038 1.18361 12.0008L2.25896 10.92ZM5.78025 16.5745C6.07868 16.8715 6.56134 16.8703 6.85829 16.5719C7.15524 16.2734 7.15404 15.7908 6.8556 15.4938L5.78025 16.5745ZM1.71824 10.6977C1.29723 10.6977 0.955942 11.039 0.955942 11.46C0.955942 11.881 1.29723 12.2222 1.71824 12.2222V10.6977ZM23.0625 12.2222C23.4835 12.2222 23.8248 11.881 23.8248 11.46C23.8248 11.039 23.4835 10.6977 23.0625 10.6977V12.2222ZM5.78025 6.34623L1.18361 10.92L2.25896 12.0007L6.8556 7.42696L5.78025 6.34623ZM1.18361 12.0008L5.78025 16.5745L6.8556 15.4938L2.25896 10.92L1.18361 12.0008ZM1.71824 12.2222L23.0625 12.2222V10.6977L1.71824 10.6977V12.2222Z",
    fill: "#E45343"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8555 16.034C10.8555 19.402 13.5858 22.1323 16.9538 22.1323H23.0522C26.4202 22.1323 29.1506 19.402 29.1506 16.034V6.88645C29.1506 3.51841 26.4202 0.788086 23.0522 0.788086H16.9538C13.5858 0.788086 10.8555 3.51841 10.8555 6.88645",
    stroke: "#E45343",
    strokeWidth: 1.52459,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/Logout.84baa115521d81ff2276e316407e4e81.svg";
export { ForwardRef as ReactComponent };